import { create } from 'zustand';

interface CalendarDialogState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useCalendarDialogStore = create<CalendarDialogState>(set => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
